// ==============================================
// Tokens bought page (/tokens/bought)
// ==============================================
//
// Where Stripe comes back to after a top-up pack bought from the Scout (Tony, 3 Nov 2026):
// the payment opens in the Scout's web view, so this page needs no sign-in and only says
// what happened and how to get back. `?cancelled=1` is Stripe's cancel return.
//
// The web view has no close button of its own; it closes itself on a polaris:// link
// (WebViewActivity, as Help's "Exit to Polaris"), which puts the skipper back on
// VortexNav's download, still open.
//
// @docs:
//   - docs/planning/TOKEN_LEDGER_PLAN.md

import { useSearchParams } from 'react-router-dom';

export function TokensBoughtPage() {
  const [params] = useSearchParams();
  const cancelled = params.get('cancelled') === '1';

  return (
    <div
      className="flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-4"
      style={{ minHeight: 'var(--vortex-usable-height, 100vh)' }}
    >
      <div className="max-w-lg w-full rounded-2xl border border-slate-700 bg-slate-800/80 p-8 text-center">
        <h1 className="text-2xl font-semibold text-white">{cancelled ? 'Payment cancelled' : 'Payment received'}</h1>
        {cancelled ? (
          <p className="mt-4 text-base text-slate-300">Nothing was charged.</p>
        ) : (
          <>
            <p className="mt-4 text-base text-slate-300">
              Your tokens arrive on your Scout within a minute. Back on your download, tap Check again.
            </p>
            <p className="mt-3 text-base text-slate-400">Your invoice is on its way by email, and in MyPolaris › Billing.</p>
          </>
        )}
        <a href="polaris://home"
          className="mt-8 block w-full rounded-xl bg-cyan-500 px-6 py-4 text-lg font-semibold text-slate-900 hover:bg-cyan-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-300">
          Back to your download
        </a>
      </div>
    </div>
  );
}

export default TokensBoughtPage;
